import {
  Redirect,
  Route,
  Switch,
  BrowserRouter as Router,
} from 'react-router-dom';
import routes from './routes';
import PrivateRoute from './components/PrivateRoute';
import NotFound from './screens/NotFound';
import { LicenseInfo } from '@mui/x-license-pro';
import AdminRoute from './components/AdminRoute';

LicenseInfo.setLicenseKey(
  '0d6add24bc9c8648fba29a2a28231e5dTz01NDExOSxFPTE3MDAxNTU0ODM3MjUsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y'
);

function App(props) {
  const routeComponent = (r) => {
    return (
      <r.component
        form={r.form}
        buttons={r.buttons}
        content={r.content}
        title={r.title}
        titleSubmitted={r.titleSubmitted}
      />
    );
  };

  if (props.test) {
    return (
      <Switch>
        {routes
          .filter((r) => !r.layout)
          .map((r) => (
            <Route exact={r.exact} path={r.path} key={r.path}>
              {routeComponent(r)}
            </Route>
          ))}
        <Route exact path={'/'}>
          <Redirect to="/login" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    );
  }
  return (
    <Router>
      <Switch>
        {routes
          .filter((r) => !r.layout)
          .map((r) =>
            r.private ? (
              r.admin ? (
                <AdminRoute exact={r.exact} path={r.path} key={r.path}>
                  {routeComponent(r)}
                </AdminRoute>
              ) : (
                <PrivateRoute exact={r.exact} path={r.path} key={r.path}>
                  {routeComponent(r)}
                </PrivateRoute>
              )
            ) : (
              <Route exact={r.exact} path={r.path} key={r.path}>
                {routeComponent(r)}
              </Route>
            )
          )}
        <Route exact path={'/'}>
          <Redirect to="/login" />
        </Route>
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
}

export default App;
